// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/activities\"},{\"path\":\"/addentry\"},{\"path\":\"/billing\"},{\"path\":\"/calendar\"},{\"path\":\"/categories\"},{\"path\":\"/colororder\"},{\"path\":\"/cookie-policy\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/profile\"},{\"path\":\"/terms-of-use\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.9";import * as Sentry from "@sentry/nextjs";

// Do not auto-initialize Sentry - it will be initialized conditionally based on consent
// in ConditionalAnalytics component

// Export Sentry configuration for conditional initialization
export const sentryConfig = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 1,
  enableLogs: true,
  debug: false,
};

// Only initialize Sentry if explicitly called (for conditional loading)
export function initSentry() {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init(sentryConfig);
  }
}

export const onRouterTransitionStart = process.env.NODE_ENV === 'production' ? Sentry.captureRouterTransitionStart : () => {};